<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-column !flex h-full justify-evenly rounded-2xl bg-white">
        <div class="flex-align-center !flex justify-between border-b border-solid p-4">
            <p></p>
            <p class="font-semibold">{{ 'SELECT_ROUTE_DIRECTION' | translate }}</p>
            <button (click)="cancel()" mat-icon-button [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="content flex-1 overflow-y-auto overflow-x-hidden">
            <mat-radio-group>
                <ng-container *ngFor="let option of routePatternStops; let i = index">
                    <div class="mx-4 py-4">
                        <mat-radio-button
                            [value]="patternLabels[i]"
                            [checked]="selectedOption === option"
                            (change)="handleDirectionChange(option)">
                            <p>{{ patternLabels[i] }}</p>
                        </mat-radio-button>
                    </div>
                    <mat-divider></mat-divider>
                </ng-container>
            </mat-radio-group>
        </div>
        <div class="m-4">
            <button
                class="pn-app-light:text-white pn-app-light:bg-primary pn-light:bg-primary pn-light:text-white vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                (click)="handleSaveClick()">
                {{ 'SELECT_LABEL' | translate }}
            </button>
        </div>
    </div>
</div>
